import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { subscribeWriteWarnings } from '@/lib/api/client';
import { useToast } from '@/lib/ui';
import { warningText } from './mediaRoles';

/**
 * One app-level notice for the `meta.warnings` a save returns (a share image that will be
 * cropped, a favicon that will be enlarged, a JPEG logo with no transparency). The save has
 * already succeeded; this says what may look wrong and stays non-blocking. Mounted once in the
 * app shell so every screen that saves a share image (pages, collections, families, settings)
 * gets it without wiring of its own.
 */
export function MediaWarningsToaster() {
  const { t } = useTranslation();
  const toast = useToast();
  useEffect(
    () =>
      subscribeWriteWarnings((warnings) => {
        const lines = [...new Set(warnings.map((w) => warningText(t, w)))];
        toast.warning(
          t('mediaRole.warningsToastTitle'),
          <ul className="flex list-disc flex-col gap-xs ps-md">
            {lines.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>,
        );
      }),
    [t, toast],
  );
  return null;
}
